import { searchGeocoderRanked } from './geocoder-ranked-search'

export default {
  /*
   * get() obtiene la dirección a partir de los parámetros
   * del campo origen o destino del planificador
   */
  get(params) {
    return searchGeocoderRanked(params, { searchKey: 'address' })
  },
  // Return direction, params have url lat and lng
  getDirectionLatLng(params) {
    let url = `${params.url}/reverse?lat=${params.lat}&lon=${params.lng}`
    return Vue.http.get(url).then(response => response)
  }
}
